/**
 * FP10 — Four-stage filtration section (scroll wheel + text reveal).
 * Supports multiple `[data-fp10-six-step]` instances with one shared window listener.
 */
(function () {
  'use strict';

  var registry = new Map();
  var windowBound = false;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFloatText(root) {
    var els = root.querySelectorAll('.float-text');
    if (!els.length) return;

    if (prefersReducedMotion()) {
      els.forEach(function (el) {
        el.classList.add('active');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  function setActiveStage(state, stage) {
    state.items.forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-stage-index'), 10) || 0;
      el.classList.toggle('active', stage >= idx);
    });
  }

  function onWheelGlobal(e) {
    if (isMobileViewport() || prefersReducedMotion()) return;
    if (e.deltaY <= 0) return;

    var candidates = [];
    registry.forEach(function (state) {
      if (!state.sectionEl || !state.stepTotal) return;
      var rect = state.sectionEl.getBoundingClientRect();
      if (rect.top < 150 && state.currentStage < state.stepTotal) {
        candidates.push({ state: state, top: rect.top });
      }
    });
    if (!candidates.length) return;

    candidates.sort(function (a, b) {
      return a.top - b.top;
    });
    var chosen = candidates[0].state;

    e.preventDefault();
    if (!chosen.isProcessing) {
      chosen.isProcessing = true;
      chosen.currentStage += 1;
      setActiveStage(chosen, chosen.currentStage);
      window.setTimeout(function () {
        chosen.isProcessing = false;
      }, 400);
    }
  }

  function onScrollGlobal() {
    if (isMobileViewport()) return;

    var windowHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    registry.forEach(function (state) {
      if (!state.sectionEl) return;
      var rect = state.sectionEl.getBoundingClientRect();
      if (rect.top > windowHeight) {
        state.currentStage = 0;
        state.isProcessing = false;
        setActiveStage(state, 0);
      }
    });
  }

  function bindWindowOnce() {
    if (windowBound) return;
    windowBound = true;
    window.addEventListener('wheel', onWheelGlobal, { passive: false });
    window.addEventListener('scroll', onScrollGlobal, { passive: true });
  }

  function unbindWindowIfEmpty() {
    if (registry.size > 0) return;
    window.removeEventListener('wheel', onWheelGlobal);
    window.removeEventListener('scroll', onScrollGlobal);
    windowBound = false;
  }

  function registerWheelState(root) {
    var sectionEl = root.querySelector('[data-fp10-six-step-panel]');
    if (!sectionEl) return null;

    var items = sectionEl.querySelectorAll('.filtration-item[data-stage-index]');
    var stepTotal = items.length;
    if (!stepTotal) return null;

    var state = {
      sectionEl: sectionEl,
      items: items,
      stepTotal: stepTotal,
      currentStage: 0,
      isProcessing: false,
    };

    registry.set(root, state);
    bindWindowOnce();
    return state;
  }

  function unregisterWheelState(root) {
    registry.delete(root);
    unbindWindowIfEmpty();
  }

  function initFp10SixStep(root) {
    if (!root || root.getAttribute('data-fp10-six-step-initialized') === 'true') return;

    root.setAttribute('data-fp10-six-step-initialized', 'true');
    initFloatText(root);
    registerWheelState(root);

    root._fp10SixStepTeardown = function () {
      unregisterWheelState(root);
      root.removeAttribute('data-fp10-six-step-initialized');
      root._fp10SixStepTeardown = null;
    };
  }

  function initAll() {
    document.querySelectorAll('[data-fp10-six-step]').forEach(initFp10SixStep);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-six-step]').forEach(initFp10SixStep);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-six-step]').forEach(function (root) {
      if (root._fp10SixStepTeardown) root._fp10SixStepTeardown();
    });
  });
})();
